import { Navigate } from 'react-router-dom'
import { useAppSelector } from '@app/hooks/reduxHooks'
import { WithChildrenProps } from '@app/types/general-types'

const RequireAuth = ({ children }: WithChildrenProps) => {
  const isAuthenticated = useAppSelector((state) => state.auth?.isAuthenticated)

  if (!isAuthenticated) return <Navigate to='/auth/login' replace />

  return <>{children}</>
}

export default RequireAuth
